import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 120000, // Timeout set to 2 minutes§
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add the auth token to headers
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-sh-auth'] = token;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Response interceptor to handle responses and errors
api.interceptors.response.use(response => response, error => {
  // You can add retry logic or specific error handling here
  return Promise.reject(error);
});

export default api;
